import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Header from './components/Header';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ProjectsPage from './pages/ProjectsPage';
import ProjectDetailPage from './pages/ProjectDetailPage';
import AdminPage from './pages/AdminPage';
import ShareRedirectPage from './pages/ShareRedirectPage';
import PostsListPage from './pages/PostsListPage';
import PostPage from './pages/PostPage';
import ChatPage from './pages/ChatPage';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="container mt-24 text-secondary">Loading...</div>;
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  return children;
}

function AdminRoute({ children }) {
  const { user, profile, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="container mt-24 text-secondary">Loading...</div>;
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  if (profile?.role !== 'admin') return <Navigate to="/" replace />;
  return children;
}

function GuestRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="container mt-24 text-secondary">Loading...</div>;
  if (user) return <Navigate to="/" replace />;
  return children;
}

function AppLayout({ children }) {
  return (
    <>
      <Header />
      {children}
    </>
  );
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<GuestRoute><LoginPage /></GuestRoute>} />
      <Route path="/register" element={<GuestRoute><RegisterPage /></GuestRoute>} />
      <Route path="/" element={
        <ProtectedRoute><AppLayout><ProjectsPage /></AppLayout></ProtectedRoute>
      } />
      <Route path="/project/:id" element={
        <ProtectedRoute><AppLayout><ProjectDetailPage /></AppLayout></ProtectedRoute>
      } />
      <Route path="/admin" element={
        <AdminRoute><AppLayout><AdminPage /></AppLayout></AdminRoute>
      } />
      <Route path="/posts" element={<AppLayout><PostsListPage /></AppLayout>} />
      <Route path="/posts/:id" element={<AppLayout><PostPage /></AppLayout>} />
      <Route path="/chat" element={
        <ProtectedRoute><ChatPage /></ProtectedRoute>
      } />
      <Route path="/s/:code" element={<ShareRedirectPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
